import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { FinishPinwheelLinkRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { FinishPinwheelLinkResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const finishPinwheelLink = (request: FinishPinwheelLinkRequest, options?: CashRequestOptions) =>
  post<FinishPinwheelLinkRequest, FinishPinwheelLinkResponse>('/2.0/cash/finish-pinwheel-link', request, {
    ...options,
    rejectOnError: true,
  })
